import React, { useState, useEffect, useMemo } from "react";
import { API } from "../../pages/backend";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import {
  Avatar,
  Box,
  Button,
  Card,
  Container,
  Grid,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../forms/input/TextInput/InputField";
import Spinner from "../ui/Spinner";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { showModal } from "../../store/reducers/modal";
import Tab from "../../Component/tab";
import TransactionCard from "../transactioncard/transactioncard";
import PubSchReceipt from "../../paymentcomp/publicschreceipt";
import { logOutUser } from "../../store/reducers/user";
import { MdErrorOutline } from "react-icons/md";
import { MdDone } from "react-icons/md";
import ResponsiveFormButton from "../ui/button/ResponsiveFormButton";
import SchoolBaseBillCard from "../paymentcard/SchoolBaseBillcard";
import InvoiceButtonWithConfirmation from "../InvoiceButtonWithConfirmation";

const Requisition = ({ examName, examType }) => {
  const [tab, setTab] = useState(0);
  const tabs = [
    "User Details",
    "Payment Details",
    "Transaction Details",
    // "Log Payment Dispute",
  ];

  const dispatch = useDispatch();
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);

  const [noOfCandidates, setNoOfCandidates] = useState(0);
  const [category, setCategory] = useState("");
  const [payerId, setPayerId] = useState("");

  const [schoolData, setSchoolData] = useState([]);
  console.log("schol data", schoolData);

  const price =
    examName === "BECE"
      ? category === "4"
        ? schoolData?.[4]?.SALE_PRICE
        : category === "2"
        ? schoolData?.[2]?.SALE_PRICE
        : null
      : examName === "CAS/Placement"
      ? schoolData?.[0]?.SALE_PRICE
      : null; // Default value if no condition matches


  // const [priceInt, setPriceInt] = useState(price.replace(/\D/g, ""));
  const totalFee = price * noOfCandidates;

  // const charge = useMemo(() => {
  //   let ch = 0.01 * totalFee
  //   if (ch > 3000) return 3000;
  //   return chs
  // }, [totalFee]);

  const totalAmount = parseInt(totalFee);

  const schoolDetails = useSelector((state) => state.user.data.details);

  const user = useSelector((state) => state.user.data.details?.user);

  const token = useSelector((state) => state?.user?.data?.token);
  // const details = useSelector(
  //   (state) => state?.transactionDetails?.data?.transactionDetails
  // );
  // console.log(details.payerId)

  // console.log(token);
  const [loading, setLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const navigate = useNavigate();

  const [payerIdData, setPayerIdData] = useState(null);
  const [payerIdError, setPayerIdError] = useState();
  const [isReadOnly, setIsReadOnly] = useState(false); // State to track if the input should be read-only

  // Set `payerId` and read-only status based on `schoolDetails.payerId`
  useEffect(() => {
    if (schoolDetails?.payerId) {
      setPayerId(schoolDetails.payerId);
      setIsReadOnly(true); // Make input read-only if `schoolDetails.payerId` is available
    } else {
      setIsReadOnly(false); // Allow input to be editable if no `schoolDetails.payerId`
    }
  }, [schoolDetails]);

  const [anchorEl, setAnchorEl] = useState(null);
  // const handleLogOut = () => {
  //   dispatch(logOutUser())
  //   navigate("/bece/payment/login");
  // };

  // const billUrl = examName === 'BECE' ? `${API}/bills/04?parameter=${details?.payerId}` : `${API}/bills/03?parameter=${details?.payerId}`;
  const billUrl =
    examName === "BECE"
      ? `${API}/bills/04?parameter=${schoolDetails?.schoolId}`
      : `${API}/bills/03?parameter=${schoolDetails?.schoolId}`;

  const openAnchor = Boolean(anchorEl);
  const [errors, setErrors] = useState({});

  const closeAnchor = () => {
    setAnchorEl(null);
  };

  const goBack = () => {
    window.history.back();
  };

  const generateCode = async () => {
    const examAssessmentCode = examName === "BECE" ? "04" : "03";
    setLoading(true);

    try {
      // console.log("here");
      const body = {
        assessmentCode: examAssessmentCode,
        totalPaidForOrAllocated: schoolDetails?.quota,
        paymentOwners: [{ examIdOrSchoolId: schoolDetails?.schoolId }],
      };
      const response = await axios.post(`${API}/code/generate`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.status === "success") {
        // console.log(response);
        // console.log("got here");
        dispatch(
          showModal({
            content: (
              <PubSchReceipt
                {...response}
                tx_ref={"-"}
                name={user?.firstName + " " + user?.lastName}
                examCode={response?.data?.data?.details?.examNo}
                examType={examName}
                email={user?.email}
                noOfCandidates={schoolDetails?.quota}
                price={"-"}
              />
            ),
          })
        );
        // const remaining = schoolDetails?.quota - noOfCandidates
        // schoolDetails?.quota = remaining;
        window.history.back();
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: `Unable to generate Exam Code. Something went wrong`,
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      setLoading(false);
    }
  };

  const updatePublic = async () => {
    // console.log(noOfCandidates);
    const remaining = schoolDetails?.quota - noOfCandidates;
    // console.log(remaining);

    const body = {
      quota: remaining,
    };
    // const beceUpdate = `${API}school/${id}/04`;
    // const casUpdate = `${API}school/${id}/03`;
    // const updateUrl =  examName === "BECE" ? beceUpdate : casUpdate ;
    const beceQuotaUpdateUrl = `${API}/school/${schoolDetails?.id}/04`;
    const casQuotaUpdateUrl = `${API}/school/${schoolDetails?.id}/03`;

    const updateQuotaUrl =
      examName === "BECE" ? beceQuotaUpdateUrl : casQuotaUpdateUrl;
    try {
      const response = await axios.patch(updateQuotaUrl, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response?.data?.status === "success") {
        // console.log(response?.data?.data?.details?.quota);

        window.history.back();
        // dispatch(setschoolDetails(response?.data?.data?.details?.quota))
      }
    } catch (error) {
      // console.log(error);
    }
    // updateGeneral(remaining, name, email, phone);
    // generateCodeUpdate();
  };

  const validateForm = () => {
    const newErrors = {};
    console.log("Validating form - noOfCandidates:", noOfCandidates, "type:", typeof noOfCandidates);
    if (!noOfCandidates || noOfCandidates <= 0) {
      newErrors.noOfCandidates = "No of candidates is required";
      console.log("Validation failed: noOfCandidates is invalid");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClickPublic = async (e) => {
    e.preventDefault();
    // const remaining = user?.quota - noOfCandidates;
    try {
      await generateCode();
      updatePublic();
      // setRemaining(remaining);
    } catch {
      toast.error("Cannot download code, please try again later");
    }
  };

  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
    } catch (error) {}
  };

  const getBeceCasBillables = async () => {
    const beceBillables = `${API}/cbs/bece_billables`;
    const casBillables = `${API}/cbs/cas_billables`;
    const examBillable_url = examName === "BECE" ? beceBillables : casBillables;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
      setSchoolData(res?.data?.data);
      // console.log(schoolData);
    } catch (error) {
      // console.log(error);
    }
  };

  const updateSchoolDetails = async (id) => {
    const beceUpdate = `${API}/school/${id}/04`;
    const casUpdate = `${API}/school/${id}/03`;
    const updateUrl = examName === "BECE" ? beceUpdate : casUpdate;

    try {
      const res = await axios.patch(
        updateUrl,
        { payerId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log(res);
    } catch (error) {
      // console.log(error);
    }
  };
  const updateSchoolPayerId = async () => {
    try {
      await axios.patch(
        `${API}/school/${schoolDetails?.schoolId}/${
          examName === "BECE" ? "04" : "03"
        }`,
        {
          payerId: payerId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Payer ID updated successfully!");
    } catch (error) {
      console.error("Failed to update payer ID:", error);
      toast.error("Failed to update payer ID. Please try again.");
    }
  };

  const schoolsDBPayerIdVerification = async () => {
    if (!payerId) return; // Skip if no input
    const body = {
      schoolId: user?.schoolId,
      assessmentCode: examName === "BECE" ? "04" : "03",
    };

    try {
      const res = await axios.post(
        `${API}/innotelligent/school/payer_details`,
        body,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log(res)
      if (
        res.status === 200 &&
        payerId === res?.data?.data?.customer?.[0]?.PAYER_ID
      ) {
        setPayerIdError(null);
        // console.log(res?.data?.data?.customer?.[0]?.CUSTOMER_NAME)
        setPayerIdData(res?.data?.data?.customer?.[0]);
        toast.success(
          `Payer ID verified successfully, Customer Name: ${res?.data?.data?.customer?.[0]?.CUSTOMER_NAME}`
        );
        // Call the update function here
        await updateSchoolPayerId();
      }
    } catch (error) {
      if (error) {
        cbsPayerIdVerification();
      }
      // console.log(error)
    }
  };
  useEffect(() => {
    if (isReadOnly) {
      schoolsDBPayerIdVerification();
    }
  }, [payerId, isReadOnly]);

  const cbsPayerIdVerification = async () => {
    try {
      const res = await axios.get(
        `${API}/cbs/customer_details?payerId=${payerId}`
      );
      // console.log(res);
      if (
        res.status === 200 &&
        payerId === res?.data?.data?.customer?.[0]?.PAYER_ID
      ) {
        setPayerIdError(null);
        // console.log(res?.data?.data?.customer?.[0]?.CUSTOMER_NAME);
        setPayerIdData(res?.data?.data?.customer?.[0]);
        toast.success(
          `Payer ID verified successfully, Customer Name: ${res?.data?.data?.customer?.[0]?.CUSTOMER_NAME}`
        );

        // Call the update function here
        // await updateSchoolPayerId();
      }
    } catch (error) {
      if (error?.response && error?.response?.status === 404) {
        setPayerIdData(null);
        setPayerIdError(error?.response?.data?.message);
        toast.error(error?.response?.data?.message);
      }
      // console.log(error);
    }
  };

  const generateBillNo = async () => {
    // Start the timeout
    let timeoutId = setTimeout(() => {
      setShowTimeoutModal(true);
    }, 120000); // 2 minutes in milliseconds

    const fullDesc =
      examName === "CAS/Placement"
        ? "Placement (Primary) All Primary Registration Fee[NGN]"
        : "Basic Education Certification[NGN]";

    const body = {
      payer_id: payerId,
      customer_name: `${payerIdData?.CUSTOMER_NAME}`,
      selected_quantities: [parseInt(noOfCandidates)],
      selected_items: [
        examName === "BECE"
          ? category === "4"
            ? schoolData?.[4]?.PRODUCTS_ID
            : category === "2"
            ? schoolData?.[2]?.PRODUCTS_ID
            : null
          : examName === "CAS/Placement"
          ? parseInt(schoolData?.[0]?.PRODUCTS_ID)
          : null, // Default value if no condition matches
      ],
      // selected_tariffs: [examName === "BECE" ? parseInt(3000) : parseInt(5000)], ///retake bece
      selected_tariffs: [
        examName === "BECE"
          ? category === "4"
            ? schoolData?.[4]?.SALE_PRICE
            : category === "2"
            ? schoolData?.[2]?.SALE_PRICE
            : null
          : examName === "CAS/Placement"
          ? parseInt(schoolData?.[0]?.SALE_PRICE)
          : null, // Default value if no condition matches
      ], //original bece price
      assessmentCode: examName === "BECE" ? "04" : "03",
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // If the request completes successfully, clear the timeout
      clearTimeout(timeoutId);

      console.warn(res?.status)
      if (res?.status === 200) {
        // console.log(res?.data);

        updateSchoolDetails(schoolDetails?.id);

        const billdata = {
          schoolId: schoolDetails?.schoolId,
          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          amountGenerated: totalFee,
          // customerName: `${user?.firstName} ${user?.lastName}`,
          customerName: schoolDetails?.schoolName,
          quantity: noOfCandidates,
          assessmentCode: examName === "BECE" ? "04" : "03",
          item:
            examName === "BECE"
              ? category === "4"
                ? schoolData?.[4]?.PRODUCTS_ID
                : category === "2"
                ? schoolData?.[2]?.PRODUCTS_ID
                : null
              : examName === "CAS/Placement"
              ? parseInt(schoolData?.[0]?.PRODUCTS_ID)
              : null, // Default value if no condition matches
        };
         saveGeneratedBill(billdata);
        // console.log(bill)

        const userTransactionDetails = {
          payerName: `${user?.firstName} ${user?.lastName}`,

          productQuantity: noOfCandidates,
          price: totalFee,
          unitPrice: price,
          examType,
          paymentExamType: examName,
          fullDesc,
          billNumber: res?.data?.data?.bill_number,
          payerId: payerId,
          address: schoolDetails?.address,
          schoolName: schoolDetails?.schoolName,
          priceWithCharge: totalAmount,
        };
        dispatch(setTransactionDetails(userTransactionDetails));
        console.log("Invoice generated successfully! Navigating to /invoice", userTransactionDetails);
        // Use replace to ensure navigation happens and prevent back button issues
        navigate("/invoice", { replace: true });
      }
    } catch (error) {
      // Clear the timeout in case of an error
      clearTimeout(timeoutId);
      
        if (axios.isAxiosError(error)) {
          const backendMessage = error.response?.data?.message || "Something went wrong";
          toast.error(backendMessage);
        } else {
           toast.error("Unable to generate invoice, please try again later.");
        }
      // console.log(error);
    }
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true);

    try {
      // e.preventDefault();
      if (validateForm()) {
        console.log("Validation passed, generating bill...");
        await generateBillNo();
        console.log("Bill generation completed");
        return true; // Success
      } else {
        toast.error("No of candidates is required");
        return false; // Validation failed
      }
    } catch (error) {
      // console.log(error);
      toast.error("Unable to generate invoice. Please try again later.");
      return false; // Error occurred
    } finally {
      setInvoiceLoading(false);
    }
  };

  const categories = [
    {
      label: "Cec Private",
      value: "4",
    },
    {
      label: "full Private/Cec Public",
      value: "2",
    },
  ];
  const isInvoiceDisabled =
  (isReadOnly && noOfCandidates <= 0) ||
  (!isReadOnly && (!payerIdData || noOfCandidates <= 0)) ||
  !price;


  const ReqForm = () => {
    return (
      <Container sx={{ mt: 2 }}>
        {showTimeoutModal && (
          <Modal
            show={showTimeoutModal}
            onHide={() => setShowTimeoutModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Server Delay</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              The bill generation is taking longer than expected. This may be
              due to a delay from our third-party server. Please wait a moment
              and try again later.
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowTimeoutModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        <div
          style={{
            marginTop: window.innerWidth >= 500 ? "3rem" : "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            // alignItems: "center",
            padding:
              window.innerWidth >= 1280
                ? "0px 60px"
                : window.innerWidth >= 414
                ? "0px 0px"
                : "0px",
            // border: "solid 2px black",
          }}
        >
          <>
            <div>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <InputField
                    name="school_type"
                    label="School Type"
                    type="schooltype"
                    placeholder="School Type"
                    value={schoolDetails?.schoolType}
                    readOnly={true}
                    style={{ height: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputField
                    name="name_of_school"
                    label="Name of School"
                    type="nameofschool"
                    placeholder="Name of School"
                    value={schoolDetails?.schoolName}
                    readOnly={true}
                    style={{ height: "100%" }}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <InputField
                    name="lga_id"
                    label="LGA ID"
                    type="localGovtId"
                    placeholder="Local Government ID"
                    value={schoolDetails?.lgaId}
                    readOnly={true}
                    style={{ height: "100%" }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <InputField
                    name="Examination_code"
                    label="Exam Code"
                    type="ExaminationCode"
                    placeholder="Examination Code"
                    value={schoolDetails?.schoolCode}
                    readOnly={true}
                    style={{ height: "100%" }}
                  />
                </Grid>
              </Grid>
            </div>

            <Typography variant="body1" sx={{ mt: 5, fontWeight: "bold" }}>
              Payer Details:
            </Typography>
            <div>
              <Grid container spacing={2}>
                {/* <Grid item xs={12} md={6}>
                  <InputField
                    name="name"
                    label="Name"
                    type="name"
                    placeholder="Name"
                    value={user?.firstName + " " + user?.lastName}
                    // readOnly={statuss? true : false}
                    // onChange={(e) => {
                    //     setUsername(e.target.value);
                    // }}
                    style={{ height: "100%", textTransform: "capitalize" }}
                  />
                  {errors.name && (
                    <div style={{ color: "red", fontSize: "15px" }}>
                      {errors.name}
                    </div>
                  )}
                </Grid> */}
                {/* <Grid item xs={12} md={6}>
                  <InputField
                    name="email"
                    label="Email"
                    type="email"
                    placeholder="Email"
                    value={user?.email}
                    // onChange={(e) => {
                    //     setUsername(e.target.value);
                    // }}
                    style={{ height: "100%" }}
                  />
                  {errors.email && (
                    <div style={{ color: "red", fontSize: "15px" }}>
                      {errors.email}
                    </div>
                  )}
                </Grid> */}
              </Grid>

              <div>
                {user?.categoryId === "01" ? (
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <InputField
                        name="no_of_candidates"
                        label="No of Candidates"
                        placeholder="Number of candidates"
                        value={schoolDetails?.quota || 0}
                        readOnly={true}
                        style={{ height: "100%" }}
                      />
                      {/* {errors.phone && (
                                    <div style={{ color: "red", fontSize: '15px' }}>{errors.phone}</div>
                                )} */}
                    </Grid>
                    <Grid item xs={6}>
                      <InputField
                        name="quota"
                        label="Quota"
                        placeholder="Quota"
                        type="quota"
                        value={schoolDetails?.quota || 0}
                        readOnly={true}
                        style={{ height: "100%" }}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <>
                    {examName === "BECE" && (
                      <Grid container spacing={2}>
                        <Grid item xs={6} md={12}>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "#9b9494",
                              fontSize: "1rem",
                              fontWeight: "bolder",
                              paddingTop: "16px",
                            }}
                          >
                            Category
                          </Typography>
                          <TextField
                            // label="Select Category"
                            select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            style={{
                              height: "100%",
                              width: "100%",
                            }}
                          >
                            {categories.map((item) => (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    )}
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            position: "relative",
                          }}
                        ></div>

                        <InputField
                          name="payerId"
                          label="Payer ID"
                          type="payer_ID"
                          placeholder="Payer ID or No"
                          value={payerId}
                          onBlur={() => schoolsDBPayerIdVerification()} // Verify only if input is editable
                          onChange={(e) => {
                            if (!isReadOnly) setPayerId(e.target.value); // Allow changes only if not read-only
                          }}
                          readOnly={isReadOnly} // Set input to read-only based on the state
                          style={{ height: "100%" }}
                        />

                        {payerIdError ? (
                          <span
                            style={{
                              fontSize: "14px",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: "5px",
                              color: "red",
                            }}
                          >
                            Payer ID unverified <MdErrorOutline />
                          </span>
                        ) : payerIdData ? (
                          <span
                            style={{
                              fontSize: "14px",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: "5px",
                              color: "green",
                            }}
                          >
                            Payer ID verified <MdDone />
                          </span>
                        ) : null}
                      </Grid>

                      <Grid item xs={6}>
                        <InputField
                          name="fee_per_candidate"
                          label="Fee per Candidate"
                          type="fee_per_candidate"
                          placeholder="Fee per candidate"
                          value={price || ""}
                          readOnly
                          style={{ height: "100%" }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <InputField
                          min="0"
                          type="number"
                          name="no_of_candidates"
                          label="No of Candidates"
                          // type='no_of_candidates'
                          placeholder="Number of Candidates"
                          value={noOfCandidates || ""}
                          onChange={(e) => {
                            setNoOfCandidates(e.target.value.trim());
                          }}
                          style={{ height: "100%" }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <InputField
                          name="totalFee"
                          label="Total Fee"
                          type="totalFee"
                          placeholder="Total Fee"
                          value={totalFee ? "₦" + totalFee : "₦" + 0}
                          readOnly={true}
                          style={{ height: "100%" }}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </div>
            </div>

            <div
              style={{
                marginTop: "3rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                {/* <Link
                component="button"
                // to="/"
                sx={{ color: "#000", textDecoration: "none" }}
              > */}
                <ResponsiveFormButton
                  label={"Go Back"}
                  onClick={goBack}
                  type="button"
                />

                {/* </Link> */}
              </div>
              {user?.categoryId === "01" ? (
                <ResponsiveFormButton
                  label={loading ? <Spinner width="30" /> : " Download Code"}
                  onClick={handleClickPublic}
                  type="button"
                />
              ) : (
       <InvoiceButtonWithConfirmation
  invoiceLoading={invoiceLoading}
  handleInvoiceClick={handleInvoiceClick}
  disabled={isInvoiceDisabled}
/>
              )}
            </div>
          </>
        </div>
      </Container>
    );
  };

  useEffect(() => {
    getBeceCasBillables();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category]);

  return (
    <div>
      {/* <Layout> */}
      <Card className="bece-card">
        <Box
          component="form"
          noValidate
          autoComplete="off"
          className="bece-form-left"
          onSubmit={(e) => e.preventDefault()}
        >
          <div style={{ padding: "0px 5px" }}>
            <marquee bgcolor="white" direction="left" loop="">
              <Typography>
                <span
                  style={{
                    color: "red",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  *Late Registration attracts an additional fee
                </span>
              </Typography>
            </marquee>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "5px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  paddingTop: "10px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    // marginLeft: "10px",
                    // paddingTop: "8px",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                  }}
                >
                  Welcome back
                </Typography>
                {/* <Typography
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {user?.firstName + " " + user?.lastName}
                </Typography> */}
              </div>
              <div>
                <Avatar
                  className=" lg:!flex xs:!hidden items-center"
                  size="large"
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                  aria-label="account-circle"
                  style={{
                    backgroundColor: "#34A56F",
                    // lineHeight: '50px',
                    fontFamily: "Palanquin",
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    width: "35px",
                    height: "35px",
                  }}
                >
                  {user?.firstName?.charAt(0)?.toUpperCase() +
                    user?.lastName?.charAt(0)?.toUpperCase()}
                </Avatar>
                <Popover
                  open={openAnchor}
                  anchorEl={anchorEl}
                  onClose={closeAnchor}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem onClick={() => dispatch(logOutUser())}>
                    Logout
                  </MenuItem>
                </Popover>
              </div>
            </div>
          </div>
          <div>
            <Typography
              variant="h4"
              align="center"
              style={{
                padding: "0px 5px",
                fontWeight: "bold",
                marginTop: "10px",
              }}
            >{`${examName}`}</Typography>
            <Typography
              variant="h5"
              align="center"
              style={{
                padding: "0px 5px",
                fontWeight: "bold",
                marginTop: "10px",
              }}
            >
              {"Requisition Form"}
            </Typography>
          </div>
          <div>
            {user?.categoryId === "01" ? (
              <Tab
                text={"User Details"}
                active={0 === tab}
                onClick={() => setTab(0)}
              />
            ) : (
              tabs.map((x, i) => (
                <Tab
                  tabs={tabs}
                  key={i}
                  text={x}
                  active={i === tab}
                  onClick={setTab}
                />
              ))
            )}
          </div>
          {/* {tab === 0 && ReqForm()} */}
          {tab === 0 && ReqForm()}
          {tab === 1 && (
            <SchoolBaseBillCard url={billUrl} examName={examName} />
          )}
          {tab === 2 && <TransactionCard />}
          {/* {tab === 3 && <PaymentDispute type={examType} />} */}
        </Box>
        <Box component="div" className="bece-form-right">
          <Typography
            variant="h4"
            align="center"
            sx={{ color: "#ffffff", fontWeight: "bold" }}
          >
            Lagos State Exam Board
          </Typography>

          <img
            src={
              "/assets/images/laags.png"
            }
            alt="logo"
          />
          <Typography
            variant="h4"
            align="center"
            sx={{ color: "white", fontWeight: "bold", mb: 1 }}
          >
            {examName}
          </Typography>
          <Typography
            variant="body2"
            align="center"
            style={{
              color: "white",
              fontSize: "20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            Fill the form to request for the Official Central Billing System
            Invoice ID
          </Typography>
        </Box>
      </Card>
      {/* </Layout> */}
      {/* <ProceedModalPrint
                open={open}
                handleClose={handleClose}
                handleFalse={handleFalse}
            /> */}
    </div>
  );
};

export default Requisition;
